<template>
  <!-- 选择付款方式-- -->
  <div>
    <div v-if="$store.state.winType.isCouponFrom == 'pay'">
      <Coupon @toChenckCoupon="openCoupon" :couponData="availableList" />
    </div>
    <div :class="{ style_none: $store.state.winType.isCouponFrom == 'pay' }">
      <div
        class="page_win payBox"
        v-if="$store.state.winType.isPayType && windowsShow"
      >
        <div class="topContent">
          <div class="topContent_m">
            <span>确认付款</span>
          </div>
          <div class="closeBtn">
            <img :src="closeImg" @click="close" />
          </div>
        </div>
        <div class="bottomContent">
          <div class="bottomContentItem bottomContentItem2">
            <p class="left_text">购买商品</p>
            <p>{{ payInfo.productName }}</p>
          </div>
          <div class="bottomContentItem2" v-if="showInfo.isCoupon == 0">
            <p>
              <img
                class="coupon_icon"
                src="@/assets/img/new2/coupon.png"
                alt=""
              />
              <span>代金卷: </span>
              <span style="color: #ff913a" @click="couponListClick"
                >{{ availableList.length }}张可用></span
              >
            </p>
            <!-- <p class="price" v-if="coupon==null">-￥0</p> -->
            <p class="price" v-if="coupon">-￥{{ coupon.reduceMoney }}</p>
          </div>
          <div class="recharge_msg">
            <p class="recharge_nub">充值金额</p>
            <p>
              <span class="price" :class="{ price2: coupon }"
                >￥{{ payInfo.money/100*showInfo.payDiscount }}</span
              >
              <span class="price" v-if="coupon">￥{{ coupon.payMoney }}</span>
            </p>
          </div>
          <p class="payWay">请选择支付方式</p>
          <div
            class="bottomContentItem3"
            v-for="(item, idx) of payList"
            :class="{ bottomContentItem4: idx == 0 }"
            :key="idx"
            @click="selectActive = item.value"
            v-show="isWeb ? idx == 0 : true"
          >
            <div class="bottomContentItem_l">
              <div class="bottomContentItem_icon">
                <img
                  :src="item.img"
                  class="wxpayImg"
                  :class="{ wxpayImg2: idx == 1 }"
                />
              </div>
              <p>{{ item.name }}</p>
              <span
                class="bottomContentItem_l_tip"
                v-if="
                  item.text != '' && item.text != 'null' && item.text != null
                "
                >&nbsp;{{ item.text }}&nbsp;</span
              >
            </div>
            <img
              :src="selectImg"
              class="arrowImg"
              v-if="selectActive === item.value"
            />
          </div>
          <div class="bot_btn" @click="payMoneyNow">立即付款</div>
          <div class="tipText" @click="toService">
      <span>如遇问题，请联系</span
      ><span class="text_r">【点击浮标客服咨询】</span>
    </div>
        </div>
      </div>
      <div v-if="qrcode || paySuccess">
        <div class="code-div" v-if="qrcode">
          <div>
            <img
              src="../../assets/img/close_black.png"
              class="close-img"
              @click="close"
            />
            <p class="title-p">确认付款</p>
            <img :src="qrcode" class="qrcode-img" />

            <p class="pay-p" v-if="coupon">
              支付：<span>￥{{ coupon.payMoney }}</span>
            </p>
            <p class="pay-p" v-else>
              支付：<span>￥{{ payInfo.money/100*showInfo.payDiscount }}</span>
            </p>
            <p class="tip-p">请使用微信扫码支付</p>
          </div>
        </div>

        <div class="paySuccessDiv" v-if="paySuccess">
          <div class="content">
            <img
              src="../../assets/img/close_black.png"
              class="close-img"
              @click="close"
            />
            <div>
              <img src="../../assets/img/wxpay.png" />
              <p>支付成功</p>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { hex_md5 } from "@/common/js/md5.js";
import { loginFcmFum } from "@/common/js/fcm";
import fun from "@/common/js/common";
import Coupon from "./coupon.vue";
let setInt2 = null;
export default {
  props: ["payInfo"],
  inject:["innerToService"],
  components: { Coupon },
  data() {
    return {
      showInfo: "",
      userInfo: "",
      adid: "",
      coupon: "",
      ref:"user",
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
      payList: [
        {
          name: "微信支付",
          img: require("../../assets/img/view8/wxpay.png"),
          text: "",
          value: "wechat",
        },
        {
          name: "支付宝支付",
          img: require("../../assets/img/view8/ali.png"),
          text: "首单随机立减,最高至免单11",
          value: "alipay",
        },
      ],
      selectImg: require("../../assets/img/view6/select.png"), // 选中支付方式
      paySuccess: false,
      selectActive: "wechat", // 支付类型
      payType: "",
      windowsShow: true,
      qrcode: "",
      isWeb: false,
      wechatCode: "",
      weChatParameter: "", // 微信内支付所需要的参数
      wxurl: "",
      wxappid: "",
      gameId: "", //gameId 游戏id
      availableList: [],
    };
  },
  watch: {
    qrcode(val) {
      if (!val) {
        setInt2 && clearInterval(setInt2);
      }
    },
  },
  created() {
    this.windowsShow = true;

    this.adid = fun.getQueryString("adid");
    this.ref = localStorage.getItem("ref");
    this.showInfo = JSON.parse(localStorage.getItem("showInfo"));
    this.payList[0].text = this.showInfo.wxPayShow;
    this.payList[1].text = this.showInfo.aliPayShow;
    console.log(this.payList);
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    //获取用户信息
    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
    // 是否是微信内
    this.wechatType = this.isWeixn();
    if (this.wechatType) {
      this.payType = "WEHCAT-GZH";
    } else {
      this.payType = "WXPAY-APP-IOS";
    }

    this.deskIcon = localStorage.getItem("deskIcon")
      ? JSON.parse(localStorage.getItem("deskIcon"))
      : "";
    this.browserRedirect();
  },
  mounted() {
    this.wxappid = localStorage.getItem("wxappid");
    this.wechatCode = localStorage.getItem(this.wxappid)
      ? localStorage.getItem(this.wxappid)
      : "";
    this.gameId = localStorage.getItem("gameId");
    if (this.showInfo.isCoupon == 0) {
      this.selectAvailableCoupon();
    }
  },
  methods: {
    toService() {
      this.innerToService();
    },
    //查看优惠卷列表
    couponListClick() {
      this.$store.dispatch("IsCouponFromFun", "pay");
    },
    openCoupon(val) {
      this.coupon = JSON.parse(val);
      console.log(this.coupon, "接受选中的优惠券");
    },
    //获取可用优惠卷
    selectAvailableCoupon() {
      let data = {
        money: this.payInfo.money,
        adId: this.adid,
        memberId: this.userInfo.uid,
        token: this.userInfo.token,
      };
      let _that = this;
      this.$http
        .post(fun.apiUrl + "api/coupon/game/available", data)
        .then((res) => {
          if (res.body.code === 200) {
            if (res.body.data != null) {
              _that.availableList = res.body.data;
            }
          }
        });
    },
    // 判断是否在微信内
    isWeixn() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    close() {
      setInt2 && clearInterval(setInt2);
      this.qrcode = "";
      this.$store.dispatch("IsPayTypeFun", false);
    },

    // 立即付款
    payMoneyNow() {
      var isPay = true;
      //实名检测
      if (localStorage.getItem("userInfo")) {
        console.log(this.userInfo);
        var loginStatus = loginFcmFum(
          this.userInfo.payFcm,
          this.userInfo.fcm,
          this.userInfo.age
        );
        if (loginStatus == "0") {
          isPay = false;
          this.$toast.text("请先实名认证，再选择购买商品");
          this.close();
          let _this = this;
          setTimeout(function () {
            _this.$store.dispatch("IsReconiseInfoFun", true);
          }, 1000);
        }
        if (loginStatus == "2") {
          isPay = false;
          this.$toast.text("未成年人玩家不可购买游戏商品");
        }
      }
      if (isPay) {
        // this.isShowPay = false
        if (this.wechatType && this.selectActive === "alipay") {
          this.$toast.text("请打开浏览器进行支付宝支付");
          return false;
        }

        if (this.browserRedirect()) {
          // this.addOrder()
          this.addOrderNew();
        } else {
          // this.pcPay()
          this.pcPayNew();
        }
      }
    },
    pcPayNew() {
      //pc支付
      this.time = new Date().getTime();
      var md5Value =
        this.payInfo.money +
        this.userInfo.uid +
        this.adid +
        (this.payInfo.serverId || this.payInfo.serverid) +
        parseInt(this.time / 1000);
      this.sign = hex_md5(md5Value);
      let data = {
        adid: this.adid,
        time: parseInt(new Date().getTime() / 1000),
        device_params: this.$store.state.deviceData,
        token: this.userInfo.token,
        couponMenberId: this.coupon.couponMenberId,
        uid: this.userInfo.uid,
        uname: this.userInfo.uname,
        serverid: this.payInfo.serverId, // 服务器id
        servername: this.payInfo.serverName, // 服务器id
        roleid: this.payInfo.roleId,
        rolename: this.payInfo.roleName,
        rolelevel: this.payInfo.roleLevel,
        productid: this.payInfo.productId,
        productname: this.payInfo.productName,
        money: this.payInfo.money,
        extension: this.payInfo.ext,
        ext: this.payInfo.ext,
        payType: "WECHAT_QRCODE",
        os: this.$store.state.deviceData.os,
        sign: this.sign,
      };
      let _that = this;
      this.$http.post(fun.apiUrl + "api/member/addOrder", data).then((res) => {
        if (res.body.code === 200) {
          console.log(res, "pc支付返回参");
          _that.payPcMoney(res.body.data.orderid);
          this.windowsShow = false;
        } else {
          this.$toast.text(res.body.message || res.body.msg);
        }
      });
    },
    pcPay() {
      //pc支付
      this.time = new Date().getTime();
      var md5Value =
        this.payInfo.money +
        this.userInfo.uid +
        this.adid +
        (this.payInfo.serverId || this.payInfo.serverid) +
        parseInt(this.time / 1000);
      this.sign = hex_md5(md5Value);
      let data = {
        adid: this.adid,
        time: parseInt(new Date().getTime() / 1000),
        device_params: this.$store.state.deviceData,
        token: this.userInfo.token,
        uid: this.userInfo.uid,
        uname: this.userInfo.uname,
        serverid: this.payInfo.serverId, // 服务器id
        servername: this.payInfo.serverName, // 服务器id
        roleid: this.payInfo.roleId,
        rolename: this.payInfo.roleName,
        rolelevel: this.payInfo.roleLevel,
        productid: this.payInfo.productId,
        productname: this.payInfo.productName,
        money: this.payInfo.money,
        extension: this.payInfo.ext,
        ext: this.payInfo.ext,
        payType: "WECHAT_QRCODE",
        os: this.$store.state.deviceData.os,
        sign: this.sign,
      };
      let _that = this;
      this.$http.post(fun.apiUrl + "api/member/addOrder", data).then((res) => {
        if (res.body.code === 200) {
          console.log(res, "pc支付返回参");
          _that.payPcMoney(res.body.data.orderid);
          this.windowsShow = false;
        } else {
          this.$toast.text(res.body.message || res.body.msg);
        }
      });
    },
    //pc支付
    payPcMoney(orderId) {
      this.payType = "WECHAT-GZH";
      let data = {
        orderId: orderId,
        payType: "WECHAT_QRCODE",
        code: this.wechatCode,
      };
      let _that = this;

      var httpUrl = this.showInfo.payUrl;
      if (
        httpUrl == null ||
        httpUrl == "" ||
        httpUrl == "null" ||
        httpUrl == undefined
      ) {
        httpUrl = fun.apiUrl + "paycenter/pay/prepay";
      }

      this.$http.post(httpUrl, data).then(
        (res) => {
          if (res.body.code === 200) {
            console.log(res.body.data, "二维码出来");
            _that.qrcode = res.body.data.qrcode;
            setInt2 = setInterval(() => {
              _that.wenPay(orderId);
            }, 1500);
          }
        },
        function (res) {}
      );
    },
    wenPay(orderId) {
      var httpUrl = this.showInfo.payStatusUrl;
      if (
        httpUrl == null ||
        httpUrl == "" ||
        httpUrl == "null" ||
        httpUrl == undefined
      ) {
        httpUrl = fun.apiUrl + "paycenter/pay/payQuery";
      }
      this.$http.post(httpUrl, { orderId }).then(
        (res) => {
          if (res.body.code === 200) {
            console.log(res, "轮询");
            setInt2 && clearInterval(setInt2);
            this.qrcode = "";
            this.paySuccess = true;
            var _that = this;
            setTimeout(() => {
              _that.$store.dispatch("IsPayTypeFun", false);
              _that.paySuccess = false;
            }, 5000);
          }
        },
        function (res) {}
      );
    },
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          sUserAgent
        )
      ) {
        this.isWeb = false;
        //跳转移动端页面
        return true;
      } else {
        this.isWeb = true;
        //跳转pc端页面
        return false;
      }
    },
    addOrderNew() {
      this.time = new Date().getTime();
      var md5Value =
        this.payInfo.money +
        this.userInfo.uid +
        this.adid +
        this.payInfo.serverId +
        parseInt(new Date().getTime() / 1000);
      this.sign = hex_md5(md5Value);

      let data = {
        adid: this.adid,
        time: parseInt(new Date().getTime() / 1000),
        device_params: this.$store.state.deviceData,
        token: this.userInfo.token,
        uid: this.userInfo.uid,
        couponMenberId: this.coupon.couponMenberId,
        uname: this.userInfo.uname,
        serverid: this.payInfo.serverId, // 服务器id
        servername: this.payInfo.serverName, // 服务器id
        roleid: this.payInfo.roleId,
        rolename: this.payInfo.roleName,
        rolelevel: this.payInfo.roleLevel,
        productid: this.payInfo.productId,
        productname: this.payInfo.productName,
        money: this.payInfo.money,
        extension: this.payInfo.ext,
        ext: this.payInfo.ext,
        payType: this.payType,
        os: this.$store.state.deviceData.os,
        sign: this.sign,
      };
      this.$http.post(fun.apiUrl + "api/member/addOrder", data).then(
        function (res) {
          if (res.body.code === 200) {
            this.$store.dispatch("IsPayTypeFun", false);
            this.payMoney(res.body.data.orderid);
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },

    addOrder() {
      this.time = new Date().getTime();
      var md5Value =
        this.payInfo.money +
        this.userInfo.uid +
        this.adid +
        this.payInfo.serverId +
        parseInt(new Date().getTime() / 1000);
      this.sign = hex_md5(md5Value);

      let data = {
        adid: this.adid,
        time: parseInt(new Date().getTime() / 1000),
        device_params: this.$store.state.deviceData,
        token: this.userInfo.token,
        uid: this.userInfo.uid,
        uname: this.userInfo.uname,
        serverid: this.payInfo.serverId, // 服务器id
        servername: this.payInfo.serverName, // 服务器id
        roleid: this.payInfo.roleId,
        rolename: this.payInfo.roleName,
        rolelevel: this.payInfo.roleLevel,
        productid: this.payInfo.productId,
        productname: this.payInfo.productName,
        money: this.payInfo.money,
        extension: this.payInfo.ext,
        ext: this.payInfo.ext,
        payType: this.payType,
        os: this.$store.state.deviceData.os,
        sign: this.sign,
      };
      this.$http.post(fun.apiUrl + "api/member/addOrder", data).then(
        function (res) {
          if (res.body.code === 200) {
            this.$store.dispatch("IsPayTypeFun", false);
            this.payMoney(res.body.data.orderid);
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },

    // 获取URL的参数
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined"
        ? ""
        : context;
    },
    getWxCode() {
      this.wxurl = escape(window.location.href);
      //获取code
      this.wechatCode = this.getQueryString(this.wxappid);
      console.log(this.wechatCode);
      if (
        this.wechatCode != null &&
        this.wechatCode != "" &&
        this.wechatCode != "undefined" &&
        this.wechatCode != undefined
      ) {
        this.getWeixinCode(this.wechatCode);
        localStorage.setItem(this.wxappid, this.getQueryString(this.wxappid));
      }
      this.wechatCode = localStorage.getItem(this.wxappid);
      if (
        this.wechatCode == null ||
        this.wechatCode == "" ||
        this.wechatCode == "undefined" ||
        this.wechatCode == undefined
      ) {
        let redirect_uri = escape(window.location.href);
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.wxappid +
          "&redirect_uri=" +
          redirect_uri +
          "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
      }
    },
    // 获取code
    getWeixinCode(wechatCode) {
      console.log("getWeixinCode");
      let data = {
        code: wechatCode,
        gameId: this.gameId,
      };
      this.$http
        .post(fun.apiUrl + "paycenter/pay/saveWxCodeAndCacheThisOpenId", data)
        .then(
          function (res) {},
          function (res) {}
        );
    },
    // 存储href
    setGameUrl() {
      let url = window.location.href;
      this.$http
        .post(fun.apiUrl + "api/common/ios/setLink", {
          iosLink: url,
        })
        .then(
          function (res) {},
          function (res) {}
        );
    },
    // 调起微信支付
    payMoney(orderId) {
      if (this.selectActive === "wechat") {
        if (this.wechatType) {
          // this.payType = 'WEHCAT-GZH'
          this.payType = "WECHAT-GZH";
          // 微信内支付
          console.log("微信支付---微信内支付");
          if (
            this.wechatCode == null ||
            this.wechatCode == "" ||
            this.wechatCode == "undefined" ||
            this.wechatCode == undefined
          ) {
            console.log("获取code");
            this.getWxCode();
          }
          let data = {
            orderId: orderId,
            payType: this.payType,
            code: this.wechatCode,
          };
          console.log(this.wechatCode);

          var httpUrl = this.showInfo.payUrl;
          if (
            httpUrl == null ||
            httpUrl == "" ||
            httpUrl == "null" ||
            httpUrl == undefined
          ) {
            httpUrl = fun.apiUrl + "paycenter/pay/prepay";
          }

          this.$http.post(httpUrl, data).then(
            function (res) {
              console.log(res);
              if (res.body.code === 200) {
                console.log("准备调起支付");
                localStorage.setItem("ios-wechat-url", window.location.href);
                this.weChatParameter = res.body.data;
                this.weichatPayInside(res.body.data);
              } else {
                // let redirect_uri = this.wxurl;
                let redirect_uri = escape(window.location.href);
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                  this.wxappid +
                  "&redirect_uri=" +
                  redirect_uri +
                  "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
                this.toast("授权过期，重新授权");
              }
            },
            function (res) {}
          );
        } else {
          // this.payType = 'WECHAT-H5'
          this.payType = "WXPAY-APP";
          // this.payType = "WXPAY-APP-IOS";
          //  这里是后端返回的URL直接进行跳转即可完成微信外支付
          let data = {
            orderId: orderId,
            payType: this.payType,
          };
          // this.payWechat = true
          var httpUrl = this.showInfo.payUrl;
          if (
            httpUrl == null ||
            httpUrl == "" ||
            httpUrl == "null" ||
            httpUrl == undefined
          ) {
            httpUrl = fun.apiUrl + "paycenter/pay/prepay";
          }
          let systemNub = localStorage.getItem("systemNub") || 0;
          console.log("ios系统版本号：" + systemNub);
          if (systemNub >= 15) {
            this.setGameUrl();
          }
          this.$http.post(httpUrl, data).then(
            function (res) {
              // this.$toast.text(this.payType+'返回值'+JSON.stringify(res))
              if (res.body.code === 200) {
                localStorage.setItem("ios-wechat-url", window.location.href);
                let url = res.body.data.pay_url;
                // let url = 'weixin://wap/pay?prepayid%3Dwx12115845198106fdaad88aed1273275500&package=3096627182&noncestr=1578801525&sign=298c8e4b882260c5c7ef85c7472d8b5b'
                window.location.href = url;
              } else {
                this.$toast.text(res.body.msg);
              }
            },
            function (res) {
              this.$toast.text(res.body.msg);
            }
          );
        }
      } else if (this.selectActive === "alipay") {
        this.payType = "ALIPAY-H5";

        let data = {
          orderId: orderId,
          payType: this.payType,
        };

        var httpUrl = this.showInfo.payUrl;
        if (
          httpUrl == null ||
          httpUrl == "" ||
          httpUrl == "null" ||
          httpUrl == undefined
        ) {
          httpUrl = fun.apiUrl + "paycenter/pay/prepay";
        }
        this.$http.post(httpUrl, data).then(
          function (res) {
            if (res.body.code === 200) {
              const div = document.createElement("div");
              div.innerHTML = res.body.data.AliPayHtml; //res.data是返回的表单
              document.body.appendChild(div);
              document.forms[0].submit();
              document.body.removeChild(div);
            } else {
              this.$toast.text(res.body.msg);
            }
          },
          function (res) {
            this.$toast.text("502");
          }
        );
      }
    },
    //微信内置浏览器类
    onBridgeReady(data) {
      let _this = this;
      // this.toast(data.appId)
      // var timestamp = Math.round(data.timeStamp).toString();
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          debug: true,
          appId: data.appId, //公众号名称，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
          jsApiList: ["chooseWXPay"],
        },
        function (res) {
          console.log(res);
          // this.toast(res + '调起微信支付')
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            _this.toast("支付成功");
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            this.toast("用户取消支付");
          } else {
            this.toast("支付失败");
          }
        }
      );
    },
    // 微信内支付
    weichatPayInside(data) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady(data),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady(data));
          document.attachEvent(
            "onWeixinJSBridgeReady",
            this.onBridgeReady(data)
          );
        }
      } else {
        this.onBridgeReady(data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.payBox {
  width: 6.4rem !important;
  height: auto !important;
}
.style_none {
  display: none;
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.topContent_m,
.closeBtn {
  @include flex_box(row, center, center);
}
.closeBtn {
  position: absolute;
  top: 0;
  right: 0;
  height: 0.68rem;
  width: 0.8rem;
  justify-content: flex-end;
  img {
    width: 0.3rem;
  }
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #ff913a;
    line-height: 0.68rem;
  }
}
.bottomContent {
  width: 100%;
  color: #a6a6a6;
  font-size: 12px;
  @include flex_box(column, space-between, stretch);
}
.bottomContentItem,
.bottomContentItem2,
.bottomContentItem3 {
  padding: 0 0.2rem;
  min-height: 0.46rem;
  @include flex_box(row, space-between, center);
}
.bottomContentItem2 {
  padding-bottom: 0.1rem;
}
.bottomContentItem2 p {
  @include flex_box(row, none, center);
}
.bottomContentItem3 {
  min-height: 0.7rem;
  padding: 0;
}
.bottomContentItem4 {
  border-bottom: 1px solid #e4e4e4;
}
.recharge_msg {
  border-top: 1px solid #e4e4e4;
  height: 0.56rem;
  @include flex_box(row, space-between, center);
  padding: 0 0.2rem;
}
.coupon_icon {
  width: 0.3rem;
  margin-right: 0.1rem;
}
.price {
  color: #ff913a;
}
.price2 {
  color: #949595;
  text-decoration: line-through;
}
.payWay {
  @include flex_box(row, center, center);
  text-align: center;
  background-color: #c4c4c4;
  color: #fff;
  border-radius: 0.1rem;
  height: 0.6rem;
  margin-bottom: 0.1rem;
}
.bottomContentItem_l {
  @include flex_box(row, none, center);

  .bottomContentItem_l_tip {
    float: right;
    font-size: 8px;
    line-height: 0.36rem;
    background-color: red;
    color: #fff;
    border-radius: 0.1rem;
    margin-left: 0.1rem;
  }
}
.bottomContentItem_icon {
  width: 0.7rem;
  @include flex_box(row, center, center);
}
.wxpayImg {
  width: 0.46rem;
  height: auto;
}
.wxpayImg2 {
  width: 0.4rem;
  height: auto;
}
.arrowImg {
  width: 0.4rem;
  height: auto;
}
.code-div {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000000000000000;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  color: #ff913a;
  div {
    padding: 0 30px;
    border-radius: 8px;
    background-color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .qrcode-img {
      width: 20vw;
      height: 20vw;
    }
    .title-p {
      line-height: 70px;
      font-size: 22px;
      font-weight: bold;
      text-align: center;
    }
    .pay-p {
      text-align: center;
      line-height: 50px;
      font-size: 22px;
      span {
        font-size: 26px;
        color: red;
        font-weight: bold;
      }
    }
    .tip-p {
      text-align: center;
      margin-bottom: 30px;
      font-size: 18px;
      font-weight: 500;
    }
    .close-img {
      width: 50px;
      height: 50px;
      position: absolute;
      right: 5px;
      top: 5px;
      border-radius: 50%;
    }
  }
}

.paySuccessDiv {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000000000000000;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  .content {
    width: 20vw;
    height: 20vw;
    padding: 30px;
    border-radius: 8px;
    background-color: #fff;
    position: relative;
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      img {
        width: 30%;
        height: auto;
      }
      p {
        font-size: 20px;
        margin-top: 4px;
      }
    }
    .close-img {
      width: 50px;
      height: 50rpx;
      position: absolute;
      right: 5px;
      top: 5px;
      border-radius: 50%;
    }
  }
}

.content {
  padding: 0.2rem 0 0;
  @include flex_box(column, none, center);
}

.content_row {
  padding: 0.14rem 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.1rem;
}
.tipText {
  @include flex_box(row, center, center);
  height: 0.5rem;
  color: #838383;
  .text_r {
    color: #ff913a;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view8/payType.vue